
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UpdateReferredFreelancerRequest,
} from '../models';
import {
    UpdateReferredFreelancerRequestFromJSON,
    UpdateReferredFreelancerRequestToJSON,
} from '../models';

export interface UpdateReferredFreelancerOperationRequest {
    submissionId: string;
    updateReferredFreelancerRequest: UpdateReferredFreelancerRequest;
}

/**
 * 
 */
export class EligibilityFreelancerApi extends runtime.BaseAPI {

    /**
     * Update referred freelancer details
          */
    async updateReferredFreelancerRaw(requestParameters: UpdateReferredFreelancerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateReferredFreelancer().'
            );
        }

        if (requestParameters['updateReferredFreelancerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferredFreelancerRequest',
                'Required parameter "updateReferredFreelancerRequest" was null or undefined when calling updateReferredFreelancer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/referred-freelancer`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferredFreelancerRequestToJSON(requestParameters['updateReferredFreelancerRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update referred freelancer details
          */
    async updateReferredFreelancer(requestParameters: UpdateReferredFreelancerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferredFreelancerRaw(requestParameters, initOverrides);
    }

}
